import { Switch as Switch_ } from "@chakra-ui/react"
import { forwardRef } from "react"
export const Switch = forwardRef(({...props}, ref) => {
    return <Switch_ ref={ref} {...props}>{props?.children}</Switch_>
});